<template>
    <b-card header-class="bar-color2" :body-class="bodyClass">
        <template v-slot:header>
            <timeline-header
                :date="data.date"
            />
        </template>

        <timeline-general-item
            v-for="(element, index) in data.data"
            :key="index"
            class="my-3"
            :data="element"
            @edit="$emit('edit', $event)"
            @save="$emit('save')"
        />

        <timeline-create-general-item
            :date="data.date"
            :surgery-id="surgery.id"
            :index="index"
            @save="$emit('save')"
        />

    </b-card>
</template>

<script>
    import TimelineElementMixin from "@/components/surgery/detail/timeline/TimelineElementMixin";
    import TimelineGeneralItem from "@/components/surgery/detail/timeline/TimelineGeneralItem";
    import TimelineHeader from "@/components/surgery/detail/timeline/TimelineHeader";
    import {mapState} from "vuex";
    import TimelineCreateGeneralItem from "@/components/surgery/detail/timeline/TimelineCreateGeneralItem";

    export default {
        name: "TimelineDay",
        components: {TimelineCreateGeneralItem, TimelineHeader, TimelineGeneralItem},
        mixins: [TimelineElementMixin],
        computed: {
            ...mapState(['surgery']),
        },
    };
</script>

<style scoped>

</style>